import { NavLink, useNavigate } from "react-router-dom";
import { publicUser } from "../../../../../globals/route-names";
import { useState } from "react";
import { useAuth } from "../../../../../context/AuthContext";
import { jobService } from "../../../../../services/job-service";

function SectionApplyJob({ jobId }) {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [coverLetter, setCoverLetter] = useState("");
    const [message, setMessage] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const submit = async (event) => {
        event.preventDefault();
        setMessage("");

        if (!jobId) {
            navigate(publicUser.jobs.LIST);
            return;
        }
        if (!user) {
            navigate(publicUser.pages.LOGIN);
            return;
        }
        if (user.role !== "candidate") {
            setMessage("Please use a candidate account to apply for jobs.");
            return;
        }

        setSubmitting(true);
        try {
            const data = await jobService.apply(jobId, coverLetter);
            setMessage(data.message || "Application submitted.");
        } catch (error) {
            setMessage(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className="twm-tabs-style-1">
                {message && <div className="alert alert-info">{message}</div>}
                {!jobId && (
                    <div className="alert alert-info">
                        Select a job first, then apply from the job detail page.
                    </div>
                )}
                <form className="row" onSubmit={submit}>
                    <div className="col-xl-12 col-lg-12 col-md-12">
                        <div className="form-group">
                            <label>Your Name</label>
                            <div className="ls-inputicon-box">
                                <input className="form-control" name="name" type="text" placeholder="Your name" value={user?.name || ""} readOnly />
                                <i className="fs-input-icon fa fa-user " />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12">
                        <div className="form-group">
                            <label>Email Address</label>
                            <div className="ls-inputicon-box">
                                <input className="form-control" name="email" type="email" placeholder="you@example.com" value={user?.email || ""} readOnly />
                                <i className="fs-input-icon fas fa-at" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <label>Message</label>
                            <textarea className="form-control" rows={3} placeholder="Message sent to the employer" value={coverLetter} onChange={(event) => setCoverLetter(event.target.value)} />
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                            <small>Resume uploads are managed from your candidate dashboard. You can also contact support
                                <NavLink to={publicUser.pages.CONTACT} className="site-text-primary"> here</NavLink>.
                            </small>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12">
                        <div className="text-left">
                            <button type="submit" className="site-button" disabled={submitting}>{jobId ? (submitting ? "Sending..." : "Send Application") : "Browse Jobs"}</button>
                        </div>
                    </div>
                </form>
            </div>

        </>
    )
}

export default SectionApplyJob;
